import isString from 'strings/isString'

export default (value) => {
  if (value === '') return value
  if (!isString(value)) return
  return value.replace(/([^*0-9a-zA-Z \\-])/g, '\\$1')
}
